module.exports = __webpack_public_path__ + "static/media/MostDazzlingGirlinBerlinBookCover.5101823e.jpg";